import { useQuery } from "@apollo/client";
import { ProfileIdentity } from "./profile-identity";
import {
  ApplicantProfileIdentityContainerQueryDocument,
} from "../../../../generated";
import { Empty, Skeleton } from "antd";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
import { getItem } from "../../../shared/local-storage";

export const ProfileIdentityContainer = () => {
  const applicantUserId = getItem('applicantUserId');

  const {
    data: applicantData,
    loading: applicantLoading,
    error: applicantError,
  } = useQuery(ApplicantProfileIdentityContainerQueryDocument, {
    variables: {
      applicantUserId,
    },
  });

  if (applicantLoading) {
    return <Skeleton active />;
  }

  if (
    applicantError ||
    !applicantData?.applicantUser?.personalInformation?.identityDetails ||
    !applicantData?.applicantUser?.personalInformation?.nameOnDocumentAssets
  ) {
    return (
      <Empty description="There was an error loading the data. Please try again!" />
    );
  }

  return (
    <ComponentQueryLoader
      error={applicantError}
      loading={applicantLoading}
      hasData={true}
      hasDataComponent={
        <ProfileIdentity
          data={applicantData.applicantUser}
        />
      }
    />
  );
};

